@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/text-panel/text-styling-panel/clipping-studio-text-styling-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.text-styling-panel__body::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.text-styling-panel__body::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.text-styling-panel__body::-webkit-scrollbar-corner {
  background: transparent;
}
.text-styling-panel__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.text-styling-panel__body::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.text-styling-panel__body::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.text-styling-panel__body::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.text-styling-panel__body::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.text-styling-panel {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  z-index: 20;
  font-family: "Open Sans", sans-serif;
}
.text-styling-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
}
.text-styling-panel__title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
}
.text-styling-panel__close {
  background: none;
  border: none;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.text-styling-panel__close:hover {
  color: rgba(0, 0, 0, 0.85);
}
.text-styling-panel__body {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.text-styling-panel__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.text-styling-panel__label {
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
}
.text-styling-panel__label--with-icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.text-styling-panel__font-error {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  display: block;
  cursor: default;
}
.text-styling-panel__content-input {
  width: 100%;
  padding: 8px 10px;
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  resize: vertical;
  min-height: 52px;
}
.text-styling-panel__time-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;
}
.text-styling-panel__time-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 0;
}
.text-styling-panel__time-input {
  flex: 1;
  min-width: 0;
  padding: 6px 8px;
  font-size: 12px;
  font-family: monospace;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
}
.text-styling-panel__time-now-btn {
  flex-shrink: 0;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  color: rgb(45, 187, 252);
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}
.text-styling-panel__time-now-btn:hover {
  background: rgba(45, 187, 252, 0.08);
}
.text-styling-panel__time-sep {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.text-styling-panel__dropdown {
  width: 100% !important;
  min-width: 0;
  max-width: 100%;
  display: block;
  border-radius: 6px;
}
.text-styling-panel__dropdown--size {
  flex: 1;
}
.text-styling-panel__size-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.text-styling-panel__format-btn {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.text-styling-panel__format-btn--active {
  background: #40c4ff;
  color: #fff;
  border-color: #40c4ff;
}
.text-styling-panel__format-btn:hover:not(.text-styling-panel__format-btn--active) {
  border-color: rgba(0, 0, 0, 0.54);
}
.text-styling-panel__alignment {
  display: flex;
  gap: 6px;
}
.text-styling-panel__align-btn {
  flex: 1;
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
}
.text-styling-panel__align-btn--active {
  border-color: rgb(45, 187, 252);
  color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.08);
}
.text-styling-panel__align-btn--full {
  width: 100%;
  flex: none;
}
.text-styling-panel__padding-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.text-styling-panel__padding-label {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  flex-shrink: 0;
}
.text-styling-panel__padding-input {
  width: 56px;
  padding: 4px 6px;
  font-size: 12px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
}
.text-styling-panel__padding-unit {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}
.text-styling-panel__footer {
  padding: 12px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.14);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.text-styling-panel__btn {
  width: 100%;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
}
.text-styling-panel__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.text-styling-panel__btn--primary {
  border: none;
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
}
.text-styling-panel__btn--primary:hover:not(:disabled) {
  opacity: 0.9;
}
.text-styling-panel__btn--secondary {
  border: 1px solid rgba(45, 187, 252, 0.5);
  background: rgb(255, 255, 255);
  color: rgb(45, 187, 252);
}
.text-styling-panel__btn--secondary:hover:not(:disabled) {
  background: rgb(233, 248, 255);
}
.text-styling-panel__btn--danger {
  border: none;
  background: #ef5350;
  color: rgb(255, 255, 255);
}
.text-styling-panel__btn--danger:hover:not(:disabled) {
  opacity: 0.9;
}
/*# sourceMappingURL=clipping-studio-text-styling-panel.component.css.map */
